import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("div", {
    class: "base-spacer",
    style: "height:".concat($props.h, ";")
  }, null, 4);
}